<template>
  <div class="course-create-wrap">
    <a-form :form="form">
      <a-card :bordered="false" style="box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
        <div class="info-title">
          基本信息
        </div>
        <div class="info-content" style="padding-top:25px;">
          <a-row >
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="课程名称   ">
                <a-input
                  placeholder="请输入课程名称"
                  v-decorator="[
                    'courseName',
                    {rules: [{ required: true, message: '请输入课程名称' }]},
                    {'initialValue':this.courseName}
                  ]"/>
                <!-- <span class="leave-num-count"></span> -->
              </a-form-item>
            </a-col>
          </a-row>
          <a-row >
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="课程简介   ">
                <a-textarea
                  style="height:80px;resize: none;"
                  placeholder="请输入课程简介"
                  v-decorator="[
                    'courseProfile',
                    {rules: [{ required: true, message: '请输入课程简介' }]},
                    {'initialValue':this.courseProfile}
                  ]" />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="课程封面   ">
                <div class="">
                  <div class="clearfix">
                    <a-upload
                      v-decorator="[
                        'courseCoverFile',
                        {valuePropName: 'file',getValueFromEvent: normFile,rules: [{ required: true, message: '请上传封面图片' }]},
                      ]"
                      listType="picture-card"
                      class="face-picture"
                      :showUploadList="false"
                      :action="uploadAction"
                      :headers="headers"
                      :beforeUpload="imgBeforeUpload"
                      @change="courseCoverChange"
                    >
                      <img v-if="courseCoverFile.obsObjectUrl" :src="courseCoverFile.obsObjectUrl" style="width:100%;"/>
                      <div v-else>
                        <a-icon :type="faceloading ? 'loading' : 'plus'" />
                        <div class="ant-upload-text"></div>
                      </div>
                    </a-upload>

                  </div>
                </div>
                <div class="img-tip">
                  请上传368*368像素或同比例的图片，小于5M!
                </div>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="课程详情   ">
                <j-editor
                  v-decorator="[ 'courseDetail', {} ,{'initialValue':this.courseDetail}]"
                  triggerChange></j-editor>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row >
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 4 }"
                label="所属科目   ">
                <j-dict-select-tag
                  v-decorator="['courseSubject', {rules: [{ required: false, message: '请选择所属科目' }]}, ,{}]"
                  placeholder="请选择所属科目"
                  dictCode="subject"
                  :triggerChange="true"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row >
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="课程序号   ">
                <a-input
                  placeholder="请输入课程序号"
                  v-decorator="[
                    'courseOrder',
                    {rules: [{ required: true, message: '请输入课程序号' }]},
                    {'initialValue':this.courseOrder}
                  ]"/>
                <!-- <span class="leave-num-count"></span> -->
              </a-form-item>
            </a-col>
          </a-row>
          <!-- <a-row >

            <a-form-item
              style="margin-bottom:12px;"
              :label-col="{ span: 2 }"
              :wrapper-col="{ span: 14 }"
              label="课程讲师   ">
              <div class="j-teacher-list">
                <div class="j-teacher-item" v-for="(it,i) in courseTeachers" :key="i">
                  <div class="j-teacher-item-con">
                    <div class="j-teacher-select">

                      <a-select showSearch optionFilterProp="children" placeholder="请选择老师" style="width:100px;float:left;margin-top:50px;" >
                        <a-select-option value="">请选择</a-select-option>
                        <a-select-option value="0">老师1</a-select-option>
                        <a-select-option value="1">老师2</a-select-option>
                        <a-select-option value="2">老师3</a-select-option>
                      </a-select>
                    </div>
                    <div class="j-teacher-item-upload">
                      <div class="ant-upload-select-picture-card">
                        <img v-if="courseTeachers[i].idSrc" :src="courseTeachers[i].idSrc" alt="avatar" style="width:100%"/>
                        <div v-else>
                          <a-icon :type="teachloading ? 'loading' : 'plus'" />
                        </div>
                      </div>
                    </div>
                    <div class="j-teacher-item-ctx">
                      <div class="j-teacher-item-ctx-input" style="border-bottom:1px solid #E7ECEF;outline:none;">
                        <a-input placeholder="请输入讲师名称" v-model="courseTeachers[i].teacherName" style="border:none;"/>
                      </div>
                      <div class="j-teacher-item-ctx-input">
                        <a-textarea placeholder="请输入讲师介绍" v-model="courseTeachers[i].teacherDesc" style="resize:none;border:none;outline:none;padding-top:0px;padding-bottom:0px;margin-bottom:0px;"></a-textarea>
                      </div>
                    </div>
                  </div>

                  <div class="j-teacher-item-cz" >
                    <a-dropdown :trigger="['click']">
                      <a class="ant-dropdown-link" @click="e => e.preventDefault()"> 邀请讲师</a>
                      <div slot="overlay">
                        <div class="scan-code">
                          <div class="scan-code-title">
                            微信扫描二维码
                          </div>
                          <div class="scan-code-title">
                            邀请微信好友为讲师
                          </div>
                          <div class="scan-code-img">
                            <vue-qr :text="invateUrl" :margin="0" colorDark="#333333" colorLight="#fff" :size="110"></vue-qr>
                          </div>
                        </div>

                      </div>
                    </a-dropdown>
                  </div>
                  <div class="j-teacher-item-cz" @click="clearCourseTeachers(i)">
                    清空
                  </div>
                  <div class="j-teacher-item-cz" @click="delCourseTeachers(i)" v-if="courseTeachers.length!=1">
                    删除
                  </div>
                </div>
              </div>
              <div class="j-teacher-add" style="margin-top:10px;">
                <a-button
                  style="text-align:center;width:100%;line-height:34px;height:34px;font-size:14px;background-color:#F4F5F7;border-color:#D0DBE4;color:#D0DBE4"
                  type="primary"
                  icon="plus"
                  @click="addTeacher()"
                >

                </a-button>
              </div>
            </a-form-item>
          </a-row> -->

        </div>
      </a-card>
      <a-card :bordered="false" style="margin-top:10px;box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
        <div class="info-title">
          上架信息
        </div>
        <div class="info-content" style="padding-top:25px;padding-bottom:10px;">
          <!-- <a-row >
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 4 }"
                label="所属分类   ">
                <j-dict-select-tag
                  v-decorator="['courseType', {rules: [{ required: false, message: '请选择所属分类' }]}, ,{}]"
                  placeholder="全部分类"
                  dictCode="live_course_type"
                  :triggerChange="true"/>
              </a-form-item>
            </a-col>
          </a-row> -->
          <a-row >
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 4 }"
                label="开课时间   ">
                <a-date-picker
                  style="width:100%;"
                  v-decorator="[ 'courseStartDate', {} ,{'initialValue':this.courseStartDate}]"
                  format="YYYY-MM-DD"
                  placeholder="请选择开课时间"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row >
            <a-col :span="24" >
              <a-form-item
                style="margin-bottom:0px;padding-bottom:86px;position:relative;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="获取形式   ">

                <div class="kaike-radio-list" style="padding-top:13px;">
                  <a-radio-group
                    v-decorator="[
                      'buyType',
                      {}
                    ]"
                    @change="handleChange">
                    <a-radio :value="`${1}`" style="line-height:1;">付费</a-radio>
                    <a-radio :value="`${0}`" style="line-height:1;">免费</a-radio>
                  </a-radio-group>
                </div>
                <div class="" style="position:absolute;width:600px;left:-6px;" v-if="buyType==1">
                  <a-form-item
                    style="margin-top:10px;margin-bottom:0px;"
                    :label-col="{ span: 2 }"
                    :wrapper-col="{ span: 7 }"
                    label="现价 ">
                    <a-input
                      placeholder="请输入￥0.01~50000"
                      v-decorator="[
                        'realPrice',
                        {rules: [{ required: true, message: '请输入课程现价' }]},
                        {'initialValue':this.realPrice}
                      ]"/>

                  </a-form-item>
                  <a-form-item
                    style="margin-bottom:0px;"
                    :label-col="{ span: 2 }"
                    :wrapper-col="{ span: 7 }"
                    label="原价 ">
                    <a-input
                      placeholder="请输入￥0.01~50000"
                      v-decorator="[
                        'linePrice',
                        {rules: [{ required: true, message: '请输入课程原价' }]},
                        {'initialValue':this.linePrice}
                      ]"/>

                  </a-form-item>
                </div>

              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </a-card>
      <a-card :bordered="false" style="text-align:center;padding:14px 0px;box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
        <div class="a-row">
          <a-button
            style="text-align:center;width:232px;line-height:40px;height:40px;font-size:14px;"
            type="primary"
            @click="courseCreateOk()"
          >
            保存
          </a-button>
        </div>
      </a-card>

    </a-form>
  </div>

</template>

<script>

  import JEditor from '@/components/jeecg/JEditor'
  import Vue from 'vue'
  import { ACCESS_TOKEN } from '@/store/mutation-types'

  import { addOnlineVideo, onlineInfo, updateOnlineVideo } from '@/api/api'

  import vueQr from 'vue-qr'

  import pick from 'lodash.pick'

  import _ from 'lodash'
  import moment from 'moment'

  // import moment from 'moment'
  // import pick from 'lodash.pick'
  // import { FormTypes } from '@/utils/JEditableTableUtil'
  // import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
  function getBase64 (img, callback) {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
  }
  export default {
    name: 'CourseCreate',
    components: { JEditor, vueQr },
    mixins: [],
    data() {
      return {
        invateUrl: '',
        courseId: '', // 编辑的时候的课程id
        courseName: '', // 课程名称
        courseProfile: '', // 课程简介
        courseCoverFile: {
          obsObjectUrl: ''
        }, // 课程封面
        courseDetail: '', // 课程详情
        courseSubject: '',
        courseTeachers: [
          {
              // id:"",
              idSrc: '',
              teacherDesc: '',
              teacherName: '',
              headFile: {}
          }
        ], // 课程讲师
        courseType: '0', // 所属分类
        courseStartDate: '', // 开课日期
        // remindFlag:"0",//开课提醒（1-开启，0-关闭）
        buyType: '1', // 购买形式（1-付费，0-免费）
        realPrice: '', // 价格
        linePrice: '', // 划线价

        faceloading: false,
        teachloading: false,
        courseOrder: '',
        getTypeValue: '0', // 获取方式
        kaikeValue: '0', //
        kaikeStatus: '0',
        form: this.$form.createForm(this),
        loading: false,
        imageUrl: '',
        previewVisible: false,
        previewImage: '',
        fileList: [
        //   {
        //   uid: '-1',
        //   name: 'xxx.png',
        //   status: 'done',
        //   url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
        // }
        ],
        url: {
          fileUpload: window._CONFIG['domianURL'] + '/sys/common/upload'
        }
      }
    },

    methods: {

      normFile(e) {
        console.log('Upload event:', e)
        if (Array.isArray(e)) {
          return e
        }
        return e && e.file && e.file.response && e.file.response.result
      },
      handleChange(e) {
        // console.log(t,y)
        this.buyType = e.target.value
      },
      addTeacher() {
        this.courseTeachers.push({
          idSrc: '',
          teacherDesc: '',
          teacherName: ''
        })
      },
      teacherImgChange (info, j, k) {
        if (info.file.status === 'uploading') {
          this.teachloading = true
          return
        }
        // this.courseTeachers[0].id = info.file.response.result.id;
        this.courseTeachers[0].headFile = info.file.response.result

        if (info.file.status === 'done') {
          // Get this url from response in real world.
          getBase64(info.file.originFileObj, (imageUrl) => {
            this.courseTeachers[0].idSrc = imageUrl

            this.teachloading = false
          })
        }
      },

      courseCoverChange(info, i, j) {
        if (info.file.status === 'uploading') {
          this.faceloading = true
          return
        }
        if (info.file.status === 'done') {
          this.courseCoverFile = info.file.response.result
          // getBase64(info.file.originFileObj, (imageUrl) => {

            // this.courseCoverFile['obsObjectUrl'] = imageUrl;
            this.faceloading = false

          // })
        }
      },

      imgBeforeUpload (file) {
        const isJPG = /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(file.name)

        if (!isJPG) {
          this.$message.error('只能上传图片!')
        }

        const isLt5M = file.size / 1024 / 1024 < 5
        if (!isLt5M) {
          this.$message.error('图片大小要小于5MB!')
        }
        return isJPG && isLt5M
      },
      clearCourseTeachers() {
        this.courseTeachers = [
          {
              // id:"",
              idSrc: '',
              teacherDesc: '',
              teacherName: ''
          }
        ]
      },
      delCourseTeachers(i) {
        this.courseTeachers.splice(i, 1)
      },
      courseCreateOk() {
        this.form.validateFields((err, values) => {
          if (!err) {
            // let courseCoverFile = this.courseCoverFile;

            let valuesParam = {}
            valuesParam = { ...values, courseTeachers: this.courseTeachers }
            valuesParam['courseStartDate'] = valuesParam['courseStartDate'] ? valuesParam['courseStartDate'].format('YYYY-MM-DD') : ''

            let opFun = ''
            if (_.isEmpty(this.courseId)) {
              opFun = addOnlineVideo(valuesParam)
            } else {
              valuesParam = { ...valuesParam, id: this.courseId }
              opFun = updateOnlineVideo(valuesParam)
            }

            opFun.then((res) => {
              if (res.success) {
                this.$message.success(res.message, () => {
                  this.$router.push({ path: '/onlineVideo/onlineVideoList' })
                })
              } else {
                this.$message.warning(res.message)
              }
            }).finally(() => {
              // that.confirmLoading = false;
              // that.checkedDepartNames = [];
              // that.userDepartModel.departIdList = {userId:'',departIdList:[]};

              // that.close();
            })
          }
        })
      }

    },

    created () {
      const token = Vue.ls.get(ACCESS_TOKEN)
      this.headers = { 'X-Access-Token': token }

      this.courseId = this.$route.query.courseId
      if (!_.isEmpty(this.courseId)) {
        onlineInfo({ id: this.courseId }).then((res) => {
          if (res.success) {
            console.log(res)
            let resultData = res.result
            resultData['courseStartDate'] = moment(resultData['courseStartDate'], 'YYYY-MM-DD')
            resultData['courseSubject'] = resultData['courseSubject'] + ''

            this.$nextTick(() => {
              this.form.setFieldsValue(pick(resultData, 'courseName', 'courseDetail', 'courseSubject', 'courseOrder',
              'courseProfile', 'courseStartDate', 'buyType', 'realPrice', 'linePrice', 'courseCoverFile'))
            })

            this.courseCoverFile = resultData.courseCoverFile ? resultData.courseCoverFile : { obsObjectUrl: '' }
            this.courseTeachers = resultData.courseTeachers[0] ? resultData.courseTeachers : [{ idSrc: '', teacherDesc: '', teacherName: '', headFile: {} }]

            this.courseTeachers[0]['idSrc'] = resultData.courseTeachers[0] ? resultData.courseTeachers[0].headFile.obsObjectUrl : ''

            this.buyType = resultData.buyType
          } else {
            this.$message.warning(res.message)
          }
        }).finally(() => {
          // that.confirmLoading = false;
          // that.checkedDepartNames = [];
          // that.userDepartModel.departIdList = {userId:'',departIdList:[]};

          // that.close();
        })
      }
    },
    computed: {
      uploadAction: function () {
        return this.url.fileUpload
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
<style lang="scss" scoped >
  .scan-code{
    padding:15px;
    background:#fff;
    border:1px solid #e7ecef;
    .scan-code-title{
      text-align:center;
      font-size:14px;
    }
    .scan-code-img{
      text-align:center;
      margin-top:10px;
    }
  }
  :global{
    // .ant-input:focus{
    //   border:none!important;
    //   outline:none;
    //   box-shadow:none;
    // }
  }
  .course-create-wrap{
    .info-title{
      border-bottom: 1px solid #E7ECEF;
      line-height: 50px;
      height: 50px;
      padding-left: 25px;
    }

    .info-content{
      .img-tip{
        color: #999999;
        font-size: 12px;
      }
      .ant-upload-list-picture-card{

        .ant-upload-list-item{
          width:142px!important;
          height:80px;
        }
      }
      .j-teacher-list{

        .j-teacher-item{
          .j-teacher-item-con{
            width: 499px;
            overflow: hidden;
            border: 1px solid #D0DBE4;
            border-bottom:none;
            display: inline-block;
            vertical-align: middle;
            .j-teacher-select{
              float:left;
              height:120px;
              border-right:1px solid #D0DBE4;
              padding:0px 10px;
            }
            .j-teacher-item-upload{
              width: 80px;
              float: left;
              margin-top:20px;
              margin-bottom:20px;
              .j-teacher-item-img{

              }
              .ant-upload-select-picture-card{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 80px;
                height:80px;
                margin:0px 8px;
                border:1px solid #D0DBE4;
                padding: 5px;
              }
            }
            .j-teacher-item-ctx{
              margin-left:220px;
              margin-top:20px;
              margin-bottom:20px;
            }

          }
          .j-teacher-item-cz{
            display: inline-block;
            vertical-align: middle;
            margin-left: 20px;
            color: #0091FF;
            cursor: pointer;

          }
          &:last-child{
              .j-teacher-item-con{
                border-bottom: 1px solid #D0DBE4;
              }
            }
        }
      }
      .kaike-tip{
        color:#FA6400;
        font-size: 12px;
        // line-height: 1;
      }
      .kaike-radio-list{
        line-height: 1;
        .kaike-radio-item{
          line-height: 1;
          margin-bottom: 12px;
          margin-top: 0px;
        }
      }

    }

  }

</style>
